import { format } from 'date-fns';

/**
 * 날짜를 원하는 형식으로 변환하는 함수
 * @param {string|null} dateString - ISO 형식의 날짜 문자열 (예: "2025-02-07T15:00:00")
 * @param {string} formatStr - 날짜 형식 (기본값: 'yyyy. M. d.') => 예: "2025. 2. 7."
 * @returns {string} 변환된 날짜 문자열 또는 '날짜 없음'
 */
export const formatDate = (dateString, formatStr = 'yyyy. M. d.') => {
    const dateInSeoul = dateToAsiaSeoulTimezone(dateString);
    return dateString ? format(dateInSeoul, formatStr) : '날짜 없음';
};

/**
 * 주어진 날짜를 아시아/서울 시간대로 변환
 * @param {Date|string|null} date
 * @returns {Date|null}
 */
export const dateToAsiaSeoulTimezone = (date) => {
    if (!date) {
        return null;
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }

    const seoulOffsetMinutes = 9 * 60; // 9시간 → 분
    return new Date(date.getTime() + seoulOffsetMinutes * 60 * 1000);
};